module.exports = __webpack_public_path__ + "f86dfc56ccf9d32575256707093d53fa.png";